module.exports = __webpack_public_path__ + "media/stylesheets/images/talentz/sec_problem_img04-c415a3bddfe2f213a1f6e62600927835.svg";